import * as React from 'react';
import PropTypes from 'prop-types';

import Icon from './Icon';

/**
 * SlideSeparator
 */

const SlideSeparator = ({ text, icon, layout, count }) => {
  const layoutClass = layout ? `l-${layout}` : '';
  const countClass = count ? 'l-count' : '';
  return (
    <h3 className={`slide-separator ${countClass} ${layoutClass}`}>
      <span>
        <span className="slide-separator-text" dangerouslySetInnerHTML={{ __html: text }} />
        {icon && <Icon icon={icon} />}
      </span>
    </h3>
  );
};

SlideSeparator.propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.string,
  layout: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  count: PropTypes.bool,
};

export default SlideSeparator;
